import { InjectionToken } from '@angular/core';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';

export const NGX_TIMEPICKER_THEME = new InjectionToken<NgxMaterialTimepickerTheme>('NGX_TIMEPICKER_THEME');

export const timepickerTheme: NgxMaterialTimepickerTheme = {
  container: {
    buttonColor: 'var(--fuse-primary)',
  },
  dial: {
    dialBackgroundColor: 'var(--fuse-primary)',
    dialInactiveColor: 'rgba(255,255,255,0.5)',
    dialActiveColor: 'var(--fuse-on-primary, white)',
  },
  clockFace: {
    clockHandColor: 'var(--fuse-primary)',
    clockFaceTimeActiveColor: 'var(--fuse-on-primary, white)',
  },
};
